import { render, staticRenderFns } from "./OEMDownload.vue?vue&type=template&id=f93f8b5e&scoped=true"
import script from "./OEMDownload.vue?vue&type=script&lang=js"
export * from "./OEMDownload.vue?vue&type=script&lang=js"
import style0 from "./OEMDownload.vue?vue&type=style&index=0&id=f93f8b5e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93f8b5e",
  null
  
)

export default component.exports
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(component, 'components', {QBtn});
